import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import i18n from 'i18next';
import RaisedButton from 'material-ui/RaisedButton';
import withTranslation from '../../hoc/withTranslation';
import { renderTextField } from '../../services/form';
import styles from '../../styles/styles';

const validate = values => {
    const errors = {};
    const requiredFields = [
        'name',
    ];
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = i18n.t('generic.required');
        }
    });
    if (values['name']
        !== undefined
        && values['name']
        !== null
        && values['name']
        !== ''
        && values['name'].length
        > 128) {
        errors['name'] = i18n.t('generic.access_token_form.name_length_gt_128');
    }
    return errors;
};

export class AccessTokenForm extends React.Component {

    static propTypes = {
        onFormReset: PropTypes.func,
    };

    // Render

    render() {
        const {
            handleSubmit,
            pristine,
            submitting,
            reset,
        } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div>
                    <Field
                        id="name"
                        name="name"
                        component={renderTextField}
                        label={this.props.t('generic.access_token_form.label_name')}
                        fullWidth={true}
                    />
                </div>
                <div>
                    <RaisedButton
                        style={styles.formButton}
                        label={this.props.t('generic.add')}
                        disabled={pristine || submitting}
                        type="submit"
                        primary={true}
                    />
                    <RaisedButton
                        style={styles.formButton}
                        label={this.props.t('generic.reset')}
                        type="button"
                        disabled={pristine || submitting}
                        onClick={() => {
                            reset();
                            if (this.props.onFormReset) {
                                this.props.onFormReset();
                            }
                        }}
                    />
                </div>
            </form>
        );
    }
}

export default reduxForm({
    form: 'addAccessToken',
    validate,
})(withTranslation(AccessTokenForm));



// WEBPACK FOOTER //
// src/components/accessToken/AccessTokenForm.js